export const getXZCoordinatesOnCircle = (radius, angle) => {
  const x = radius * Math.sin((Math.PI * 2 * angle) / 360);
  const z = radius * Math.cos((Math.PI * 2 * angle) / 360);
  return { x, z };
};

export const getXYZCoordinatesOnCircle = (radius, lon, lat) => {
  const x = radius * Math.sin((Math.PI * 2 * lat) / 360) * Math.cos((Math.PI * 2 * lon) / 360);
  const y = radius * Math.sin((Math.PI * 2 * lon) / 360);
  const z = radius * Math.cos((Math.PI * 2 * lat) / 360) * Math.cos((Math.PI * 2 * lon) / 360);
  return { x, y, z };
};
